/*
 * @Author: Ashley.Liu
 * @Date: 2022-06-28 15:36:08
 * @LastEditTime: 2023-02-06 16:18:15
 * @Description: desc
 */
export default {
  Search: [
    {
      index: '/search/business/list',
      name: 'Business',
      icon: 'zm-icon-building',
      roles: ['ADMIN', '*OPERATOR', '*DEVELOPER'],
      children: [
        {
          index: '/search/business/access',
          name: 'Access',
          permission: {
            resource: 'business:definition',
            action: 'C'
          }
        },
        {
          index: '/search/business/list',
          name: 'Index',
          permission: {
            resource: 'business:definition',
            action: 'R'
          }
        },
        {
          index: '/search/business/consumer',
          name: 'Consumer',
          permission: {
            resource: 'business:consumer',
            action: 'R'
          }
        }
      ]
    },
    {
      index: '/search/request',
      name: 'Request',
      icon: 'zm-icon-hide-poll',
      permission: {
        resource: 'ticket:read',
        action: 'R'
      }
    },
    {
      index: '/search/rest/terminal',
      name: 'Rest',
      icon: 'zm-icon-computer',
      roles: ['ADMIN', '*OPERATOR']
    },
    {
      index: '/search/discover',
      name: 'Discover',
      icon: 'zm-icon-object',
      permission: {
        resource: 'system:discover',
        action: 'R'
      }
    },
    {
      index: '/search/monitor',
      name: 'Monitor',
      icon: 'zm-icon-eye-off',
      children: [
        {
          index: '/search/monitor/cat',
          name: 'Cat',
          permission: {
            resource: 'es_monitor:cat',
            action: 'R'
          }
        },
        {
          index: '/search/monitor/es_task',
          name: 'Es Task',
          permission: {
            resource: 'es_monitor:es_task',
            action: 'R'
          }
        }
      ]
    },
    {
      index: '/search/index',
      name: 'Index',
      icon: 'zm-icon-list-view',
      roles: ['ADMIN', '*OPERATOR', '*DEVELOPER'],
      children: [
        {
          index: '/search/index/config',
          name: 'Config',
          roles: ['ADMIN', '*OPERATOR', 'DEVELOPER']
        },
        {
          index: '/search/index/tools',
          name: 'Tools',
          roles: ['ADMIN', '*OPERATOR', '*DEVELOPER']
        },
        {
          index: '/search/index/consistency',
          name: 'Consistency',
          roles: ['ADMIN', '*OPERATOR', 'DEVELOPER']
        },
        {
          index: '/search/index/script',
          name: 'Script',
          roles: ['ADMIN', '*OPERATOR', '*DEVELOPER']
        },
        {
          index: '/search/index/reindex',
          name: 'Reindex',
          roles: ['ADMIN', '*OPERATOR', '*DEVELOPER']
        }
      ]
    },
    {
      index: '/search/service',
      name: 'Service',
      icon: 'zm-icon-grid-view-thin',
      children: [
        {
          index: '/search/service/service-health',
          name: 'Service Health',
          permission: {
            resource: 'service_health:read',
            action: 'R'
          }
        }
      ]
    },
    {
      index: '/search/migrate',
      name: 'Migrate',
      icon: 'zm-icon-move-to',
      roles: ['ADMIN', '*OPERATOR', 'DEVELOPER'],
      children: [
        {
          index: '/search/migrate/cluster',
          name: 'Cluster Migrate',
          permission: {
            resource: 'migrate_cluster:create',
            action: 'C'
          }
        },
        {
          index: '/search/migrate/history',
          name: 'History Migrate',
          permission: {
            resource: 'migrate_history_status:read',
            action: 'R'
          }
        }
      ]
    },
    {
      index: '/search/nginx',
      name: 'Nginx',
      icon: 'zm-icon-global',
      permission: {
        resource: 'nginx:read',
        action: 'R'
      },
      children: [
        {
          index: '/search/nginx/HA-AA-Switch',
          name: 'HA-AA Switch',
          permission: {
            resource: 'nginx:read',
            action: 'R'
          }
        },
        {
          index: '/search/nginx/upstreams',
          name: 'Upsteams',
          permission: {
            resource: 'nginx:read',
            action: 'R'
          }
        },
        {
          index: '/search/nginx/keyvals',
          name: 'Keyvals',
          permission: {
            resource: 'nginx:read',
            action: 'R'
          }
        }
      ]
    },
    {
      index: '/search/cache',
      name: 'Cache',
      icon: 'zm-icon-matching',
      permission: {
        resource: 'cache:read',
        action: 'R'
      },
      children: [
        {
          index: '/search/cache/manage',
          name: 'Manage',
          permission: {
            resource: 'cache:read',
            action: 'R'
          }
        },
        {
          index: '/search/cache/compare',
          name: 'Compare',
          permission: {
            resource: 'cache:read',
            action: 'R'
          }
        }
      ]
    },
    {
      index: '/search/incident',
      name: 'Incident',
      icon: 'zm-icon-activity',
      permission: {
        resource: 'incident:read',
        action: 'R'
      }
    },
    {
      index: '/search/job',
      name: 'Job',
      icon: 'zm-icon-txt',
      permission: {
        resource: 'deploy_check:job',
        action: 'C'
      }
    },
    {
      index: '/search/business_settings',
      name: 'Biz Settings',
      icon: 'zm-icon-matching',
      roles: ['ADMIN', 'OPERATOR', 'DEVELOPER'],
      children: [
        {
          index: '/search/businessSettings/cluster',
          name: 'Cluster',
          permission: {
            resource: 'cluster_info:read',
            action: 'R'
          }
        },
        {
          index: '/search/businessSettings/businessGroup',
          name: 'BizGroup',
          permission: {
            resource: 'business_setting:group',
            action: 'R'
          }
        },
        {
          index: '/search/businessSettings/dataSource',
          name: 'DataSource',
          permission: {
            resource: 'business_setting:datasource',
            action: 'R'
          }
        }
      ]
    },
    {
      index: '/search/hbase',
      name: 'HBase',
      icon: 'zm-icon-skip-speaker',
      children: [
        {
          index: '/search/hbase/cluster',
          name: 'Cluster',
          permission: {
            resource: 'hbase:connection',
            action: 'R'
          }
        },
        {
          index: '/search/hbase/regionserver',
          name: 'RegionServer',
          permission: {
            resource: 'hbase:connection',
            action: 'R'
          }
        },
        {
          index: '/search/hbase/table',
          name: 'Table',
          permission: {
            resource: 'hbase:connection',
            action: 'R'
          }
        }
      ]
    },
    {
      index: '/search/system',
      name: 'Permission',
      icon: 'zm-icon-device-personal-zoom-rooms',
      permission: {
        resource: 'system:user',
        action: 'R'
      },
      children: [
        {
          index: '/search/system/user',
          name: 'User'
        },
        {
          index: '/search/system/role',
          name: 'Role'
        },
        {
          index: '/search/system/permission',
          name: 'Permission'
        }
      ]
    },
    {
      index: '/search/test',
      name: 'Test',
      icon: 'zm-icon-text',
      roles: ['ADMIN', 'OPERATOR', 'DEVELOPER'],
      children: [
        {
          index: '/search/test/unit',
          name: 'Unit Test'
        }
      ]
    },
    {
      index: '/search/client',
      name: 'Client',
      icon: 'zm-icon-device-filter',
      roles: ['ADMIN', '*OPERATOR', '*DEVELOPER'],
      children: [
        {
          index: '/search/client/user',
          name: 'User'
        },
        {
          index: '/search/client/poolStatus',
          name: 'Pool Status'
        },
        {
          index: '/search/client/exception',
          name: 'Exception'
        },
        {
          index: '/search/client/endpoint',
          name: 'Endpoint'
        },
        {
          index: '/search/client/visualization',
          name: 'Visualization'
        }
      ]
    },
    {
      index: '/search/gateway',
      name: 'Gateway',
      icon: 'zm-icon-skip-speaker',
      roles: ['ADMIN', '*OPERATOR', '*DEVELOPER'],
      children: [
        {
          index: '/search/gateway/gatewayRoute',
          name: 'Gateway Route'
        },
        {
          index: '/search/gateway/clusterRouting',
          name: 'ClusterRouting'
        },
        {
          index: '/search/gateway/lookupHeader',
          name: 'LookupHeader'
        },
        {
          index: '/search/gateway/failover',
          name: 'Failover'
        }
      ]
    },
    {
      index: '/search/agg/task',
      name: 'Agg',
      icon: 'zm-icon-hot-desk',
      permission: {
        resource: 'agg:read',
        action: 'R'
      }
    }
  ],
  'ES Manage': [
    {
      index: '/esinfo/cluster',
      name: 'Cluster',
      icon: 'zm-icon-activity'
    },
    {
      index: '/esinfo/index-manage',
      name: 'Index',
      icon: 'zm-icon-txt'
    },
    {
      index: '/esms/rest',
      name: 'Rest',
      icon: 'zm-icon-computer'
    },

    {
      index: '/esinfo/alarm',
      name: 'Alarm',
      icon: 'zm-icon-skip-speaker',
      children: [
        {
          index: '/esinfo/channel',
          name: 'Channel Manage'
        },
        {
          index: '/esinfo/alarm',
          name: 'Alarm Config'
        },
        {
          index: '/esinfo/alarm-records',
          name: 'Alarm Records'
        }
      ]
    },
    {
      index: '/esinfo/tools',
      name: 'Tools',
      icon: 'zm-icon-settings',
      children: [
        {
          index: '/esinfo/transfer',
          name: 'Transfer Data',
          roles: ['ADMIN', 'OPERATOR', 'DEVELOPER']
        },
        {
          index: '/esinfo/tools/analyzer',
          name: 'Analyzer'
        },
        {
          index: '/esinfo/sync',
          name: 'Sync'
        },
        {
          index: '/esinfo/jobManage',
          name: 'Job Manage'
        },
        {
          index: '/esinfo/helpDocsManage',
          name: 'Help Docs Manage'
        }
      ]
    },
    {
      index: '/esinfo/incident',
      name: 'Incident',
      icon: 'zm-icon-controller',
      permission: {
        resource: 'incident:read',
        action: 'R'
      }
    },
    {
      index: '/esinfo/role',
      name: 'Settings',
      icon: 'zm-icon-settings',
      children: [
        {
          index: '/esinfo/role',
          name: 'Role'
        },
        {
          index: '/esms/es_metrics',
          name: 'Metrics'
        },
        {
          index: '/esinfo/dictionary',
          name: 'Dictionary'
        }
      ]
    }
  ]
}
